import { type SerializedStyles } from '@emotion/react';
import { forwardRef } from 'react';
import {
  LoaderComponent, type LoaderType,
} from '~/_shared/baseComponents/loaders';
import { OverlayComponent } from './overlay.component';
import { lottieAnimationOverlayStyle } from './overlayLottieAnimation.component';

type OverlayLoaderProps = Readonly<{
  className?: string;
  loaderSize?: number;
  spinnerStyle?: SerializedStyles;
  loaderType?: LoaderType;
}>;

export const OverlayLoaderComponent = forwardRef<HTMLDivElement, OverlayLoaderProps>((props, ref) => {
  const size = props.loaderSize ?? 60;

  return (
    <OverlayComponent className={props.className} ref={ref}>
      <LoaderComponent
        css={[lottieAnimationOverlayStyle({ size }), props.spinnerStyle]}
        size={size}
        type={props.loaderType}
      />
    </OverlayComponent>
  );
});
